export default "__VITE_ASSET__DZpCIw_Q__"